<template>
    <!--otro-->
    <div class="app-container">
        <Navbar></Navbar>
        <main class="main-content">
            <router-view />
        </main>
        <Footer></Footer>
    </div>

</template>

<script>
import Navbar from './components/navegation/Navbar2.vue';
import Footer from './components/navegation/Footer.vue';
export default {
    name: "App",
    components: { Navbar, Footer },
    data() {
        return {
            isLoggedIn: false,
            isMobile: false,
            isStandalone: false,
        }
    },
    created() {
        if (window.Laravel.isLoggedin) {
            this.isLoggedIn = true
        }
        //this.isMobile = this.detectMobile();
        //this.isStandalone = this.detectStandalone();
        //this.requestNotificationPermission();
    },
    methods: {
        detectMobile() {
            return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop|BlackBerry/i.test(navigator.userAgent);
        },
        detectStandalone() {
            return (window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone;
        },
        requestNotificationPermission() {
            if ("Notification" in window) {
                Notification.requestPermission().then(permission => {
                    if (permission === "granted") {
                        this.showNotification();
                    }
                });
            }
        },
        showNotification() {
            const notification = new Notification("Hola", {
                body: "¡Bienvenido a nuestra PWA!",
                icon: "/img/icons/android-chrome-192x192.png",
                image: '/img/autumn-forest.png',
                vibrate: [300, 200, 300],
                badge: '/img/icons/plint-badge-96x96.png',
            });
            notification.onclick = () => {
                window.focus();
            };
        },
        logout(e) {
            e.preventDefault()
            this.$axios.get('/sanctum/csrf-cookie').then(response => {
                this.$axios.post('/logout')
                    .then(response => {
                        if (response.data.success) {
                            window.location.href = "/home"
                        } else {
                            console.log(response);
                        }
                    })
                    .catch(function (error) {
                        console.error(error);
                    });
            })
        }
    },
}


</script>

<style scoped>
html,
body {
    height: 100%;
    margin: 0;
}

body {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.app-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-height: 100vh;
    /* Asegura que ocupe toda la altura disponible */
}

.main-content {
    flex: 1;
    /* Esto hace que ocupe el espacio restante */
}

footer {
    padding: 10px;
    text-align: center;
    width: 100%;
    margin-top: auto;
    /* Esto empuja el footer hacia abajo */
}

@media (max-width: 1360px) {
    .content {
        margin-top: 5.75%;
        height: auto;
        width: auto;
        /* Ajusta según el tamaño del navbar */
        /* Otros estilos */
    }
}
</style>